import styled from "styled-components";

interface BasePageContainerProps {
  isMobile: boolean;
}

export const BasePageContainer = styled.div<BasePageContainerProps>`
  width: ${({ isMobile }: {isMobile: any}) => isMobile ? '50%' : '100%'};
  height: 100%;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    align-self: center;
    height: 200px;
    width: 300px;
  }

  h3 {
    font: 600 16px/1.6em 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black}
  }
`